import { useNavigate } from 'react-router-dom';

const useNavigation = () => {
  const navigatePage = useNavigate();

  const navigateTo = (action, page, id,additionalParam) => {
    console.log(`navigating to ${action} ${page}` )
    if(additionalParam) {
        navigatePage(`/${page}/${id}/${additionalParam}`);
    } else if(id) {
        navigatePage(`/${page}/${id}`);
    } else {
        navigatePage(`/${page}`);
    }
  };

  
  return { navigateTo };
};

export default useNavigation;
